import navbar from '../../../playturbo/src/lang/zh/navbar'
import ptCommon from '../../../playturbo/src/lang/zh/common'
import versionlist from '../../../playturbo/src/lang/zh/versionList'
import websocket from '../../../playturbo/src/lang/zh/websocket'
import uploader from '../../../warehouse/src/lang/zh/uploader'
import cropperDialog from '../../../warehouse/src/lang/zh/cropperDialog'
import common from '../../../warehouse/src/lang/zh/common.js'
import custom from '../../../playturbo/src/lang/zh/custom'
import commonTemplate from '../../../playturbo/src/lang/zh/commonTemplate'
import animation from './zh/animation'
import audioCutter from './zh/audioCutter'
import audio from './zh/audio'
import board from './zh/board'
import image from './zh/image'
import psNavbar from './zh/navbar'
import layerManager from './zh/layerManager'
import layoutEditor from './zh/layoutEditor'
import leftPane from './zh/leftPane'
import globalSetting from './zh/globalSetting'
import animationSetting from './zh/animationSetting'
import designSetting from './zh/designSetting'
import eventSetting from './zh/event-setting/index'
import sceneSetting from './zh/sceneSetting'
import sceneManager from './zh/sceneManager'
import sequenceFrame from './zh/sequenceFrame'
import text from './zh/text'
import utils from './zh/utils'
import video from './zh/video'
import particle from './zh/particle'
import particleParent from './zh/particleParent'
import resourceManagers from './zh/resourceManager'
import exportHistory from '@pt/lang/zh/exportHistory'
import recordProject from '@pt/lang/zh/recordProject'
import leftMenu from '@pt/lang/zh/leftMenu'
import promoteManagement from '@pt/lang/zh/promoteManagement'
import videoProject from '@pt/lang/zh/videoProject'
import playableProject from '@pt/lang/zh/playableProject'
import assetLibrary from '@pt/lang/zh/assetLibrary'
import preView from './zh/preview'
import iconText from './zh/icon'
import mixin from './zh/mixin'
import commonNavbar from '@/lang/zh/downloadBasic'
import basic from '@com/lang/zh/basic'
import track from '@com/lang/zh/track'
import creative from '@pt/lang/zh/creative'
import gamePlay from '@pt/lang/zh/gamePlay'
import resourceManager from '@com/lang/zh/resourceManager'
import playableAds from '@pt/lang/zh/playableAds'
import whole from '@pt/lang/zh/whole'
// import workbenchs from '@com/lang/zh/workbench'
import ps from './zh/ps'
import taskCenter from '@pt/lang/zh/taskCenter'
import drawLine from './zh/drawLine'
import carousel from './zh/carousel'
import pushDialog from '@pt/lang/zh/pushDialog'
import authAccount from '@pt/lang/zh/authAccount'
import box2d from './zh/box2d'
import billing from '@pt/lang/zh/billing'
import profile from '@pt/lang/zh/profile'
import dashboard from '@pt/lang/zh/dashboard'
import playComponent from './zh/playComponent'
import erase from './zh/erase'
import park from './zh/park'
import mask from './zh/mask'
import puzzle from './zh/puzzle'
import shelves from './zh/shelves'
import iv from './zh/interactive-video'

export default {
  basic,
  track,
  ps,
  // workbenchs,
  resourceManager,

  commonNavbar,
  common,
  uploader,
  cropperDialog,
  playTurbo: {
    navbar,
    common: ptCommon,
    custom,
    versionlist,
    commonTemplate,
    pushDialog,
    authAccount,
    websocket,
    creative,
    gamePlay,
    leftMenu,
    exportHistory,
    recordProject,
    videoProject,
    playableProject,
    assetLibrary,
    promoteManagement,
    whole,
    playableAds,
    taskCenter,
    billing,
    profile,
    dashboard,
  },
  icon: {
    iconText,
  },
  preview: {
    preView,
  },
  workbench: {
    animation,
    audio,
    audioCutter,
    board,
    image,
    psNavbar,
    layerManager,
    layoutEditor,
    leftPane,
    globalSetting,
    animationSetting,
    designSetting,
    eventSetting,
    sceneSetting,
    sceneManager,
    sequenceFrame,
    text,
    utils,
    video,
    particle,
    particleParent,
    resourceManagers,
    mixin,
    drawLine,
    box2d,
    playComponent,
    erase,
    carousel,
    park,
    mask,
    puzzle,
    shelves,
  },
  interactiveVideo: {
    iv,
  },
}
